<template>
  <wh-popup
    v-model="myVisible"
    :ref-form="$refs.farmWorkRecordForm"
    :title="title"
    @close="hidePopup"
    @open="popupOpen"
  >
    <van-form ref="farmWorkRecordForm" class="farm-work-record-form" label-width="60px" @submit="submitForm">
      <wh-popup-select
        :rules="rules.farmWork"
        :show-picker.sync="picker.farmWork.show"
        :show-text="form.farmWork"
        label="农事选择"
        name="farmWork"
      >
        <template #select>
          <div class="farm-work-select">
            <van-field
              v-model="customTypeInput.value"
              class="custom"
              placeholder="自定义"
              size="small"
              type="primary"
              @keyup.enter="setCustomType"
            >
              <template #button>
                <van-button
                  icon="plus"
                  native-type="button"
                  size="mini"
                  type="info"
                  @click="setCustomType"
                />
              </template>
            </van-field>
            <van-picker
              :columns="farmWorkSelectColumns"
              :default-index="farmWorkSelectIndex"
              :visible-item-count="14"
              show-toolbar
              @cancel="picker.farmWork.show = false"
              @confirm="onConfirm('farmWork', $event)"
            />
          </div>
        </template>
      </wh-popup-select>
      <agricultural-popup-select
        v-model="form.agriculturalRecordInfos"
        :rules="rules.agriculturalRecordInfos"
        @close="$refs.farmWorkRecordForm.resetValidation()"
      />
      <land-popup-select
        :company-id="currentCompanyId"
        :land-id.sync="form.landId"
        :land-name.sync="form.landName"
        :rules="rules.landId"
        :value="form.landName"
        label="地块"
      />
      <staff-popup-select
        :rules="rules.operator"
        :staff-name.sync="form.operator"
        :value="form.operator"
        label="负责人"
        placeholder="请选负责人"
      />
      <wh-field-time-popup
        v-model="form.beginTime"
        :rules="rules.beginTime"
        empty-text="开始时间"
        input-align="left"
        label="开始时间"
      />
      <wh-field-time-popup
        v-model="form.endTime"
        :rules="rules.endTime"
        empty-text="结束时间"
        input-align="left"
        label="结束时间"
      />
      <van-collapse v-model="moreFormItemActive">
        <van-collapse-item name="更多" title="更多">
          <van-field label="照片">
            <template #input>
              <wh-upload v-model="form.photo" :files-str.sync="photoStr" :uploading.sync="photoUploading" />
            </template>
          </van-field>
          <van-field v-model="form.recordDescription" label="操作详情" type="textarea" />
        </van-collapse-item>
      </van-collapse>
    </van-form>
  </wh-popup>
</template>

<script>
import { formPopup } from '@/utils/mixins/formPopup'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { FARM_WORK_TYPE } from '@/constant/common'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect'
import api from '@/api'
import AgriculturalPopupSelect from '@/views/productManage/components/PopupSelect/AgriculturalPopupSelect'
import LandPopupSelect from '@/views/productManage/components/PopupSelect/LandPopupSelect'
import StaffPopupSelect from '@/views/productManage/components/PopupSelect/StaffPopupSelect'
import { formatTime } from '@/utils/convert/convertTime'
import WhFieldTimePopup from '@/components/public/WhFieldTimePopup/WhFieldTimePopup'
import WhUpload from '@/components/public/WhUpload/WhUpload'

export default {
  name: 'FarmWorkRecordPopup',
  components: {
    WhUpload,
    WhFieldTimePopup,
    StaffPopupSelect,
    LandPopupSelect,
    AgriculturalPopupSelect,
    WhPopupSelect,
    WhPopup
  },
  mixins: [formPopup],
  data() {
    return {
      form: {
        agriculturalRecordId: undefined,
        id: undefined,
        formTimeRange: [],
        farmWork: undefined,
        beginTime: '',
        endTime: '',
        operator: undefined,
        recordDescription: '',
        landId: undefined,
        landName: undefined,
        photo: undefined,
        agriculturalRecordInfos: []
      },
      photoStr: '',
      photoUploading: false,
      rules: {
        farmWork: [{ required: true, message: '请选择农事类型', trigger: 'onBlur' }],
        landId: [{ required: true, message: '请选择地块', trigger: 'onBlur' }],
        operator: [{ required: true, message: '请选负责人', trigger: 'onBlur' }],
        agriculturalRecordInfos: [{ required: false, message: '请选投入品', trigger: 'onBlur' }],
        beginTime: [{ required: true, message: '开始时间', trigger: 'onBlur' }],
        endTime: [{ required: true, message: '结束时间', trigger: 'onBlur' }]
      },
      picker: {
        farmWork: {
          show: false
        },
        beginTime: {
          show: false
        },
        endTime: {
          show: false
        }
      },
      apiFarmWorkType: [],
      addFarmWorkType: [],
      customTypeInput: {
        value: undefined
      },
      currentCompanyId: this.$store.getters.userData.id,
      formDataShow: {
        beginTime: '',
        endTime: ''
      },
      moreFormItemActive: []
    }
  },
  computed: {
    title() {
      if (this.formType === 'create') {
        return '添加农事记录'
      } else {
        return '编辑农事记录'
      }
    },
    farmWorkSelectColumns() {
      const farmWorkTypeSet = new Set([...FARM_WORK_TYPE, ...this.apiFarmWorkType, ...this.addFarmWorkType])
      const farmWorkTypeArr = Array.from(farmWorkTypeSet)
      return farmWorkTypeArr.map(item => {
        return {
          text: item,
          value: item
        }
      })
    },
    farmWorkSelectIndex() {
      for (const index in this.farmWorkSelectColumns) {
        if (this.farmWorkSelectColumns[index].value === this.form.farmWork) {
          return index
        }
      }
      return undefined
    }
  },
  methods: {
    formatTime,
    popupOpen() {
      if (this.formType === 'create') {
        this.formDataInit(this.form)
        this.$nextTick(() => {
          this.$refs.farmWorkRecordForm.resetValidation()
        })
      } else {
        this.formDataInit(this.form, this.initFormData)
      }
      this.setAddFarmWorkType()
    },
    submitForm(form) {
      if (this.photoUploading) {
        this.$toast.loading('请等待图片上传完成...')
        return
      }
      const agriculturalRecordInfos = this.form.agriculturalRecordInfos.map(item => {
        return {
          ...item,
          changeCount: item.changeCount * 1000
        }
      })
      let apiName = 'createFarmWorkRecords'
      if (this.formType !== 'create') {
        apiName = 'updateFarmWorkRecords'
      }
      this.form.formTimeRange = undefined
      api[apiName]({
        ...this.form,
        agriculturalRecordInfos,
        photo: this.photoStr
      }).then(res => {
        this.$toast.success(res.msg)
        this.hidePopup()
        this.submitFormSuccess()
      })
    },
    onConfirm(type, val) {
      this.picker.farmWork.show = false
      this.form.farmWork = val.value
      console.log(type, val)
    },
    setCustomType() {
      const customType = this.customTypeInput.value
      if (customType) {
        if (!this.farmWorkSelectColumns.find(item => item.value === customType)) {
          this.addFarmWorkType.push(customType)
        }
        this.form.farmWork = customType
      }
      this.customTypeInput.value = ''
      this.picker.farmWork.show = false
    },
    setAddFarmWorkType() {
      api.getFarmWorkType().then(res => {
        if (res && res.data) {
          this.apiFarmWorkType = res.data.map(item => {
            return item.typeName
          })
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.farm-work-record-form {
  margin-top: 10px;
}
.farm-work-select {
  position: relative;
  .custom {
    position: absolute;
    width: 140px;
    left: 0;
    right: 0;
    z-index: 9;
    margin: auto;
  }
}
</style>
